import * as React from "react";

import {GuideStateApi, GuideStateApiContext} from "@repo/guide-state";

interface Props {
    /**
     * Children to render inside the provider.
     */
    children: React.ReactNode;
}

/**
 * Provide the state change API contexts for the AI guide.
 *
 * The reason we provide the GuideStateApi singleton instead of the state itself,
 * is that the singleton doesn't change.  This avoids full-page re-renders when
 * the state changes.
 */
export const GuideStateApiProvider = ({
    children,
}: Props): React.ReactElement => {
    // By rendering the state and the state modification API in separate
    // contexts, consumers of the modification API will only be triggered to
    // update when that API changes, which it never should, and consumers of
    // the state will only be triggered to update when all state changes have
    // been processed, which is what we want.
    return (
        <GuideStateApiContext.Provider value={GuideStateApi}>
            {children}
        </GuideStateApiContext.Provider>
    );
};
